module.exports = __webpack_public_path__ + "img/processing.9325807d.gif";